import React, { useState, useEffect } from "react";
import "./DetailProduct.css";
import { useNavigate, useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";

import { db } from "../firebase"; // adapte le chemin si nécessaire
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import SuggestProducts from "./SuggestProducts";
import { useCart } from "../CartProvider";
import { FaWhatsapp } from "react-icons/fa";

function normalizeProduct(docSnap) {
  const d = docSnap.data();

  return {
    id: docSnap.id,
    title: d?.Name ?? "Untitled",
    category: d?.Categorie?.Label ?? "",
    brand: d?.Brand ?? "",
    image: d?.ImageUrl ?? "",
    price: Number(d?.Stores?.Cassablanca?.SalePrice ?? 0),
    oldPrice: Number(d?.oldPrice ?? 0),
    badge: d?.QuantityAvailable === 0 ? "Out of Stock" : "",
    IsPack: Boolean(d?.HasChilds ?? false),
    ParentId: d?.ParentId ?? null,
    stock:
      Number(d?.Stores?.Cassablanca?.Quantity ?? 0) +
      Number(d?.Stores?.Dekon?.Quantity ?? 0) +
      Number(d?.Stores?.Baguida?.Quantity ?? 0) -
      Number(3),
    InShip: Number(d?.QuantityInPo ?? 0) + Number(d?.QuantityInShpping ?? 0),
    Images: d?.Images ?? [],
    Description: d?.Description ?? "Pas de description...",
    SubCategorie: d?.Categorie?.SubCategorie?.Id ?? null,
    MaxiDiscount: Number(d?.MaxiDiscount ?? 0),
    GetDiscount: Boolean(d?.GetDiscount ?? false),
    ApplyInvitation: Boolean(d?.ApplyInvitation ?? false),
  };
}

export default function DetailProduct() {
  const { id } = useParams();
  const navigate = useNavigate();

  const { cart, addToCart, inc, dec } = useCart();

  const [item, setItem] = useState(null);
  const [activeImg, setActiveImg] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchProduct() {
      try {
        setLoading(true);

        const docRef = doc(db, "items", id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const product = normalizeProduct(docSnap);
          setItem(product);
          setActiveImg(product.image);
          document.title = product.title;
        } else {
          setItem(null);
        }
      } catch (error) {
        console.error("Erreur chargement produit:", error);
        setItem(null);
      } finally {
        setLoading(false);
      }
    }

    if (id) fetchProduct();
  }, [id]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [id]);

  if (loading) {
  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(255, 255, 255, 0.45)",
      }}
    >
      <div
        style={{
          width: "45px",
          height: "45px",
          border: "4px solid rgba(0, 0, 0, 0.15)",
          borderTop: "4px solid rgba(0, 0, 0, 0.65)",
          borderRadius: "50%",
          animation: "spin 0.8s linear infinite",
        }}
      />

      <style>
        {`
          @keyframes spin {
            to {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
    </div>
  );
}

  if (!item) return <p>Produit introuvable.</p>;

  const qty = cart[item.id]?.qty ?? 0;
  const inCart = qty > 0;
  const stock = Number(item.stock);

  return (
    <>
      <NavBar />

      <section className="detail-wrap-detail">
        <div className="detail-grid-detail">
          <div className="detail-gallery-detail">
            <div className="detail-mainimg-detail">
              <img src={activeImg || item.image} alt={item.title} />
            </div>

            {Array.isArray(item.Images) && item.Images.length > 0 && (
              <div className="detail-thumbs-detail">
                {[item.image, ...item.Images].filter(Boolean).map((img) => (
                  <button
                    key={img}
                    onClick={() => setActiveImg(img)}
                    className={`detail-thumb-detail ${
                      activeImg === img ? "active" : ""
                    }`}
                  >
                    <img src={img} alt="thumb" />
                  </button>
                ))}
              </div>
            )}
          </div>

          <div className="detail-info-detail">
            <h1 className="detail-title-detail">{item.title}</h1>

            <p className="detail-desc-detail">{item.Description}</p>

            <div className="detail-rating-detail">
              <span className="detail-stars-detail">★ ★ ★ ★ ★ - </span>
              <span>(120)</span>
            </div>

            <div className="detail-prices-detail">
              <span className="detail-price-detail">
                {Number(item.price).toLocaleString("fr-FR")} FCFA
              </span>

              {item.oldPrice > 0 && (
                <span className="detail-oldprice-detail">
                  {Number(item.oldPrice).toLocaleString("fr-FR")} FCFA
                </span>
              )}
            </div>

            <div className="detail-stock-detail">
              {stock > 0 ? (
                "En Stock"
              ) : (
                <p style={{ color: "#dc3545" }}>
                  Ce produit est actuellement en rupture de stock et sera de
                  retour d’ici un mois, mais vous pouvez le réserver spécialement
                  en nous contactant sur WhatsApp.
                </p>
              )}
            </div>

            <div className="detail-actions-detail">
              {!inCart ? (
                stock > 0 ? (
                  <button
                    className="detail-addcart-detail"
                    onClick={() => addToCart(item.id, item)}
                    disabled={stock <= 0}
                  >
                    <span className="ico" aria-hidden="true">
                      +
                    </span>{" "}
                    Add to Cart
                  </button>
                ) : (
                  <a
                    className="detail-addcart-detail"
                    href="https://wa.me/22890045926"
                    style={{ textDecoration: "none" }}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span className="ico" aria-hidden="true">
                      <FaWhatsapp size={20} />
                    </span>{" "}
                    Whatsapp
                  </a>
                )
              ) : (
                <>
                  <div className="qty-wrap-pl">
                    <span
                      className="qty-label-pl"
                      style={{
                        fontWeight: "bold",
                        color: "black",
                        marginRight: "30px",
                      }}
                    >
                      Quantité:
                    </span>

                    <div className="qty-ctrl-pl">
                      <button onClick={() => dec(item.id)} aria-label="Decrease">
                        −
                      </button>
                      <span>{qty}</span>
                      <button
                        onClick={() => inc(item.id, stock)}
                        aria-label="Increase"
                      >
                        +
                      </button>
                    </div>
                  </div>
                  <br />
                </>
              )}

              <button
                className="detail-addcart-detail"
                onClick={() => navigate("/products")}
              >
                Continuer les achats
              </button>
            </div>

            <div className="subtotal-pl">
              <span>Sous total: </span>
              <strong>
                {(qty * Number(item.price)).toLocaleString("fr-FR")} FCFA
              </strong>
            </div>

            <div className="detail-services-detail">
              <div>
                <h4>🚚 Livraison Possible</h4>
                <p>Partout à Lomé.</p>
              </div>

              <div>
                <h4>Disponible !!!</h4>
                <p>Dans nos boutiques de Cassablanca, Dekon et Baguida.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <SuggestProducts
        idcategorie={item?.SubCategorie}
        title="Produits du même groupe"
      />

      <Footer />
    </>
  );
}
